import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService, ModalService } from 'ng-devui';
import {
  AlertDialogComponent,
  AlertDialogType,
} from 'src/app/modules/shared/components/alert-dialog/alert-dialog.component';
import { FilePreviewTypeListMap } from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import {
  TableColumnConfig,
  TableColumnOption,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { WorkReportDocType } from 'src/app/modules/shared/models/form/work-report-doc-type.enum';
import { WorkReportStatus } from 'src/app/modules/shared/models/form/work-report-status.enum';
import { JgPhysicalInspUnitFb } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fb.model';
import { JgPhysicalInspUnitFxItem } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fx-item.model';
import { JgPhysicalInspUnitItemBatchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-batch-request.model';
import { JgPhysicalInspUnitItemInfo } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-info.model';
import { JgPhysicalInspUnitItemProgressSearchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-progress-search-request.model';
import { JgPhysicalInspUnitItemProgress } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-progress.model';
import { JgPhysicalInspUnitSearchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-search-request.model';
import { JgPhysicalInspUnit } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit.model';
import {
  ProjectSectionUnitJgStatusColorMap,
  ProjectSectionUnitJgStatusMap,
} from 'src/app/modules/shared/models/jg/project-section-unit-jg-status.enum';
import { ProjectItemType } from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import {
  ProjectSectionUnitStatusColorMap,
  ProjectSectionUnitStatusMap,
} from 'src/app/modules/shared/models/project/project-section-unit-status.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { JgPhysicalInspUnitFbService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fb.service';
import { JgPhysicalInspUnitFxItemService } from 'src/app/modules/shared/services/jg-physical-insp-unit-fx-item.service';
import { JgPhysicalInspUnitItemProgressService } from 'src/app/modules/shared/services/jg-physical-insp-unit-item-progress.service';
import { JgPhysicalInspUnitService } from 'src/app/modules/shared/services/jg-physical-insp-unit.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-insp-entity-submit',
  templateUrl: './handover-insp-entity-submit.component.html',
  styleUrls: ['./handover-insp-entity-submit.component.scss'],
})
export class HandoverInspEntitySubmitComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;
  @ViewChild('scroll') scroll?: ElementRef<any>;

  config?: TableConfig = new TableConfig();

  searchRequest: JgPhysicalInspUnitSearchRequest =
    new JgPhysicalInspUnitSearchRequest();

  pager = this.globalService.recoverPager();

  totalWidth = 0;
  scrollTop = 0;
  scrollIndex = 0;
  isOpen = true;

  recordList: JgPhysicalInspUnitItemProgress[] = [];

  sectionList: ProjectSection[] = [];

  isLM = false;

  record: JgPhysicalInspUnitItemBatchRequest =
    new JgPhysicalInspUnitItemBatchRequest();

  recordTable: JgPhysicalInspUnitItemProgress[] = [];
  recordFakeTable: JgPhysicalInspUnitItemProgress[] = [];

  sectionOrgMap: { [key: string]: TableColumnOption[] } = {};

  ProjectSectionUnitJgStatusMap = ProjectSectionUnitJgStatusMap;

  ProjectSectionUnitJgStatusColorMap = ProjectSectionUnitJgStatusColorMap;

  ProjectSectionUnitStatusMap = ProjectSectionUnitStatusMap;

  ProjectSectionUnitStatusColorMap = ProjectSectionUnitStatusColorMap;

  sectionId: number;

  jgSectionId: number;

  jgPhysicalInspUnitFbList: JgPhysicalInspUnitFb[] = [];

  jgPhysicalInspUnitFxItemList: JgPhysicalInspUnitFxItem[] = [];

  jgFbCascaderOptions: NzTreeNode[] = [];

  jgFbCascaderValue: any[] = [];

  jgFxCascaderOptions: NzTreeNode[] = [];

  jgFxCascaderValue: any[] = [];

  fxItem?: JgPhysicalInspUnitFxItem;

  checkAll = false;

  mileStart = '';
  mileEnd = '';
  FilePreviewTypeListMap = FilePreviewTypeListMap;
  FileType = FileType;

  currentFile: FileResponse;

  environment = environment;

  get withToken() {
    return '?token=' + this.globalService.token;
  }

  height = 0;
  width = 0;

  pdfZoom = 1;
  pdfPages = 1;
  pdfTotal = 0;

  WorkReportDocType = WorkReportDocType;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private projectSectionService: ProjectSectionService,
    private jgPhysicalInspUnitItemProgressService: JgPhysicalInspUnitItemProgressService,
    private jgPhysicalInspUnitFbService: JgPhysicalInspUnitFbService,
    private jgPhysicalInspUnitFxItemService: JgPhysicalInspUnitFxItemService,
    private jgPhysicalInspUnitService: JgPhysicalInspUnitService,
    private globalService: GlobalService,
  ) {
    this.jgSectionId = this.activatedRoute.snapshot.params['jgSectionId'];
    this.sectionId = this.activatedRoute.snapshot.params['sectionId'];
    this.currentFile = this.globalService.getArchiveReportCache()!;
  }

  onCheckChange() {
    // recordTable 是 recordList 经里程过滤后的子集（深拷贝），不能用 index 对位。
    // 通过 id 把每条可见行的 checked 同步回 recordList。
    const idMap = new Map<number, JgPhysicalInspUnitItemProgress>();
    for (const r of this.recordList) {
      if (r.id != null) {
        idMap.set(r.id, r);
      }
    }
    for (const row of this.recordTable) {
      const orig = row.id != null ? idMap.get(row.id) : undefined;
      if (orig) {
        orig.checked = row.checked;
      }
    }
    // “全选”只反映当前可见结果是否全部勾选
    this.checkAll =
      this.recordTable.length > 0 &&
      this.recordTable.every((item) => item.checked);
  }

  onCheckAllChange() {
    // 仅对当前可见行（recordTable）生效；通过 id 反向同步到 recordList，
    // 不应连带影响被过滤掉的行。
    const idMap = new Map<number, JgPhysicalInspUnitItemProgress>();
    for (const r of this.recordList) {
      if (r.id != null) {
        idMap.set(r.id, r);
      }
    }
    for (const row of this.recordTable) {
      row.checked = this.checkAll;
      const orig = row.id != null ? idMap.get(row.id) : undefined;
      if (orig) {
        orig.checked = this.checkAll;
      }
    }
  }

  ngAfterViewInit(): void {
    window.addEventListener('resize', () => {
      this.resize();
    });
    setTimeout(() => {
      this.resize();
    }, 50);
  }

  resize() {
    this.height = document.body.clientHeight;
  }

  onPageLoad(event: any) {
    console.log(event);
    this.pdfTotal = event.source.pdfDocument._pdfInfo.numPages;
    this.resize();
  }

  prePage() {
    if (this.pdfPages > 1) {
      this.pdfPages--;
    }
  }

  nextPage() {
    if (this.pdfPages < this.pdfTotal) {
      this.pdfPages++;
    }
  }

  originSize() {
    this.pdfZoom = 1;
  }

  zoomIn() {
    this.pdfZoom += 0.1;
    if (this.pdfZoom > 2) {
      this.pdfZoom = 2;
    }
  }

  zoomOut() {
    this.pdfZoom -= 0.1;
    if (this.pdfZoom < 0.5) {
      this.pdfZoom = 0.5;
    }
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  reset() {
    this.mileEnd = '';
    this.mileStart = '';
    this.searchRecord();
  }

  ngOnInit(): void {
    this.getJgFb();
    this.getSectionList();
  }

  getSectionList() {
    this.projectSectionService
      .findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      })
      .subscribe((projectSections) => {
        this.sectionList = projectSections;
      });
  }

  getJgFb() {
    this.jgPhysicalInspUnitFbService
      .findAll({
        sectionId: this.sectionId,
        projectId: this.globalService.projectId,
        jgSectionId: this.jgSectionId,
      })
      .subscribe((res: JgPhysicalInspUnitFb[]) => {
        this.jgPhysicalInspUnitFbList = res.sort((a, b) => {
          if (a.dwCodeSort === b.dwCodeSort) {
            if (a.dwTypeNameSort === b.dwTypeNameSort) {
              return a.jgFbNameSort! - b.jgFbNameSort!;
            }
            return a.dwTypeNameSort! - b.dwTypeNameSort!;
          }
          return a.dwCodeSort! - b.dwCodeSort!;
        });
        this.jgFbCascaderOptions = this.buildJgInspUnitFbTree(res);
      });
  }

  private buildJgInspUnitFbTree(
    jgFbList: JgPhysicalInspUnitFb[],
  ): NzTreeNode[] {
    const nodes: NzTreeNode[] = [];
    if (jgFbList.length === 0) {
      return nodes;
    }
    let lastDw = '';
    for (const item of jgFbList) {
      if (lastDw !== item.dwCode) {
        nodes.push({
          label: item.dwCode! + ' ' + item.dwName!,
          value: item.dwCode! + '#' + item.dwName!,
          children: [
            {
              label: item.jgFbName!,
              value: `${item.dwCode!}#${item.dwName!}#${item.jgFbName!}#${item.jgSectionId}`,
              isLeaf: true,
            },
          ],
        });
      } else {
        nodes[nodes.length - 1].children!.push({
          label: item.jgFbName!,
          value: `${item.dwCode!}#${item.dwName!}#${item.jgFbName!}#${item.jgSectionId}`,
          isLeaf: true,
        });
      }
      lastDw = item.dwCode!;
    }

    return nodes;
  }

  onFbCascaderValueChange() {
    this.jgFxCascaderValue = [];
    this.config = new TableConfig();
    this.recordList = [];
    this.recordTable = [];
    const value = this.jgFbCascaderValue[this.jgFbCascaderValue.length - 1];
    const [dwCode, dwName, jgFbName, jgSectionId] = value.split('#');
    this.jgPhysicalInspUnitFxItemService
      .findAll({
        projectId: this.globalService.projectId,
        jgSectionId,
        sectionId: this.sectionId,
        dwCode,
        jgFbName,
      })
      .subscribe((res: JgPhysicalInspUnitFxItem[]) => {
        this.jgPhysicalInspUnitFxItemList = res.sort((a, b) => {
          if (a.jgFxProjectTypeCode === b.jgFxProjectTypeCode) {
            return a.jgInspItemCodeSort! - b.jgInspItemCodeSort!;
          }
          return (
            a.jgFxProjectTypeCode?.localeCompare(b.jgFxProjectTypeCode!) ?? 0
          );
        });
        this.jgFxCascaderOptions = this.buildJgInspUnitFxTree(
          this.jgPhysicalInspUnitFxItemList,
        );
      });
  }

  private buildJgInspUnitFxTree(
    jgFxList: JgPhysicalInspUnitFxItem[],
  ): NzTreeNode[] {
    const nodes: NzTreeNode[] = [];
    if (jgFxList.length === 0) {
      return nodes;
    }
    let lastFx = '';
    for (const item of jgFxList) {
      if (lastFx !== item.jgFxName) {
        nodes.push({
          label: `${item.jgFxName}`,
          value: `${item.jgFxName}`,
          children: [
            {
              label: `${item.jgInspItemName}`,
              value: `${item.jgInspItemName}#${item.id}#${item.lastJgRfiFormNo}`,
              isLeaf: true,
            },
          ],
        });
      } else {
        nodes[nodes.length - 1].children!.push({
          label: `${item.jgInspItemName}`,
          value: `${item.jgInspItemName}#${item.id}#${item.lastJgRfiFormNo}`,
          isLeaf: true,
        });
      }
      lastFx = item.jgFxName!;
    }

    return nodes;
  }

  onUnitFxItemChoose() {
    const id =
      this.jgFxCascaderValue[this.jgFxCascaderValue.length - 1].split('#')[1];
    const lastSn =
      this.jgFxCascaderValue[this.jgFxCascaderValue.length - 1].split('#')[2];
    this.fxItem = this.jgPhysicalInspUnitFxItemList.find(
      (item) => `${item.id}` === id,
    );
    this.recordTable = [];
    this.record.docSnNo = lastSn.padStart(3, '0');

    this.isLM = false;
    if (
      this.fxItem!.dwCode!.indexOf('L') === 0 ||
      this.fxItem!.dwCode!.indexOf('J') === 0
    ) {
      this.isLM = true;
    }
    this.initConfig();
  }

  getColor(status: string) {
    switch (status) {
      case WorkReportStatus.DRAFT:
        return '#000000';
      case WorkReportStatus.FINISH:
        return '#2b58cd';
      case WorkReportStatus.WAIT_SIGN:
      case WorkReportStatus.WAIT_SEAL:
        return '#A30014';
      case WorkReportStatus.REJECT_SIGN:
      case WorkReportStatus.REJECT_SEAL:
      case WorkReportStatus.CANCLE:
        return '#FF0000';
      default:
        return '#BDC3C7';
    }
  }

  initConfig() {
    const defaultColumn: TableColumnConfig[] = [
      {
        name: '分部工程',
        key: 'fbName',
        type: TableColumnType.text,
        width: this.isLM ? 90 : 140,
      },
      {
        name: '分部工程单元',
        key: 'subFbName',
        type: TableColumnType.text,
        width: this.isLM ? 90 : 140,
      },
      {
        name: '分项工程单元',
        key: 'sectionName',
        type: TableColumnType.text,
        width: this.isLM ? 100 : 140,
      },
    ];
    if (this.isLM) {
      defaultColumn.push({
        name: '段',
        key: 'code',
        type: TableColumnType.text,
        width: 40,
      });
      defaultColumn.push({
        name: '分段里程',
        key: 'mileage',
        type: TableColumnType.text,
        width: 100,
      });
    }

    defaultColumn.push({
      name: '施工单位',
      key: 'constructionOrgName',
      type: TableColumnType.options,
      options: this.sectionOrgMap[`${this.searchRequest.sectionId}`],
      width: 70,
    });

    defaultColumn.push({
      name: '施工资料',
      key: 'mark',
      type: TableColumnType.text,
      width: 70,
    });
    defaultColumn.push({
      name: '监理资料',
      key: 'mark',
      type: TableColumnType.text,
      width: 70,
    });

    defaultColumn.push({
      name: this.fxItem!.jgInspItemName!,
      key: this.fxItem!.jgInspItemCode!,
      type: TableColumnType.text,
      width: 80,
    });

    this.config = {
      hasIndex: true,
      columns: defaultColumn,
      headerSize: 12,
      bodySize: 13,
    };

    this.totalWidth = defaultColumn.reduce((acc, cur) => acc + cur.width, 56);

    this.searchRecord();
  }

  onScroll(event: any) {
    if (this.recordFakeTable.length > 0) {
      this.recordFakeTable = [];
    }
  }

  onScrollEnd($event?: any) {
    const startIndex = Math.floor(this.scroll?.nativeElement.scrollTop / 40);
    const viewportHeight =
      this.scroll?.nativeElement.clientHeight - (this.isOpen ? 120 : 80);
    let endIndex = Math.ceil(viewportHeight / 40) + startIndex;
    if (endIndex > this.recordList.length - 1) {
      endIndex = this.recordList.length - 1;
    }
    const offset = this.scroll?.nativeElement.scrollTop % 40;
    this.scrollTop = this.scroll?.nativeElement.scrollTop - offset;
    this.scrollIndex = startIndex;

    this.recordFakeTable = this.handleTable(
      JSON.parse(
        JSON.stringify(this.recordList.slice(startIndex, endIndex + 1)),
      ),
    );
  }

  private handleTable(recordTable: JgPhysicalInspUnit[]) {
    if (recordTable.length === 0) {
      return [];
    }
    console.log('recordTable');
    let index = recordTable.length - 1;
    while (index > 0) {
      if (recordTable[index].fbCode === recordTable[index - 1].fbCode) {
        recordTable[index].fbCode = '';
        recordTable[index].fbName = '';
        recordTable[index - 1].fbSpan = recordTable[index].fbSpan
          ? recordTable[index].fbSpan! + 1
          : 2;
        if (recordTable[index].subFbCode === recordTable[index - 1].subFbCode) {
          recordTable[index].subFbCode = '';
          recordTable[index].subFbName = '';
          recordTable[index - 1].subFbSpan = recordTable[index].subFbSpan
            ? recordTable[index].subFbSpan! + 1
            : 2;
          if (this.isLM) {
            if (
              recordTable[index].sectionCode ===
              recordTable[index - 1].sectionCode
            ) {
              recordTable[index].sectionCode = '';
              recordTable[index].sectionName = '';
              recordTable[index - 1].sectionSpan = recordTable[index]
                .sectionSpan
                ? recordTable[index].sectionSpan! + 1
                : 2;
            }
          }
        }
      }
      index--;
    }
    return recordTable;
  }

  sign(workFlowKey: string) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  onLcSearch() {
    const filteredRecords = JgPhysicalInspUnit.filterRecordsByMile(
      JSON.parse(JSON.stringify(this.recordList)),
      this.mileStart,
      this.mileEnd,
    );
    this.recordTable = this.handleTable(filteredRecords);
    this.onScrollEnd();
  }

  searchRecord() {
    this.jgPhysicalInspUnitItemProgressService
      .findAll<JgPhysicalInspUnitItemProgressSearchRequest>({
        projectId: this.globalService.projectId,
        jgSectionId: this.fxItem?.jgSectionId,
        sectionId: this.fxItem?.sectionId,
        dwCode: this.fxItem?.dwCode,
        jgFbName: this.fxItem?.jgFbName,
        jgFxName: this.fxItem?.jgFxName,
        jgFxProjectTypeCode: this.fxItem?.jgFxProjectTypeCode,
        jgInspItemCode: this.fxItem?.jgInspItemCode,
        sectionItemType: this.isLM
          ? ProjectItemType.SEGMENT
          : ProjectItemType.SECTION,
      })
      .subscribe((data: JgPhysicalInspUnitItemProgress[]) => {
        this.recordList = data ?? [];
        if (!this.isLM) {
          for (const item of this.recordList) {
            item.sectionCode = item.code;
            item.sectionName = item.name;
          }
        }
        this.recordTable = this.handleTable(
          JSON.parse(JSON.stringify(this.recordList)),
        );
        this.onScrollEnd();
      });
  }

  editing: any = {};

  edit(key: string) {
    this.editing[key] = true;
    console.log(this.editing);
  }

  onBlur(id: number, comment: string) {
    this.editing = {};
    this.jgPhysicalInspUnitItemProgressService
      .update({
        id,
        comment,
      })
      .subscribe(() => {
        this.searchRecord();
      });
  }

  cancel() {
    window.close();
  }

  get canConfirm() {
    if (
      !this.fxItem ||
      !this.record.docFinishDateDate ||
      !this.record.docSnNo
    ) {
      return false;
    }
    return true;
  }

  confirm() {
    if (!this.fxItem) {
      return;
    }
    this.jgPhysicalInspUnitService
      .batchInsp(this.buildReq())
      .subscribe((res) => {
        for (const record of res) {
          if (!!record.workFlowKey) {
            this.sign(record.workFlowKey);
          }
        }
        const errMessages = res
          .map((item) => item.errMessage)
          .filter((msg) => !!msg);
        const results = this.modalService.open({
          backdropCloseable: false,
          component: AlertDialogComponent,
          onClose: () => {},
          data: {
            title: '错误',
            content: errMessages.join('<br/>'),
            cancelBtnText: '取消',
            confirmBtnText: '确认',
            contentStyle: 'danger',
            type: AlertDialogType.simple,
            onCancel: () => {
              results.modalInstance.hide();
            },
            onConfirm: () => {
              results.modalInstance.hide();
            },
          },
        });

        if (errMessages.length === 0) {
          window.close();
        }
      });
  }

  private buildReq(): JgPhysicalInspUnitItemBatchRequest {
    const req = new JgPhysicalInspUnitItemBatchRequest(
      this.fxItem,
      WorkReportDocType.PDF_SIGNED,
      this.currentFile.fileId,
      this.currentFile.fileName,
      this.record.docSnNo,
      this.record.docSubmitDateDate?.getTime(),
      this.record.docFinishDateDate?.getTime(),
    );
    const items: JgPhysicalInspUnitItemInfo[] = [];
    for (const record of this.recordList) {
      if (record.checked && !record.jgRfiWorkFlowKey) {
        const item = new JgPhysicalInspUnitItemInfo();
        item.projectId = record.projectId;
        item.jgSectionId = record.jgSectionId;
        item.sectionId = record.sectionId;
        item.dwCode = record.dwCode;
        item.jgFbName = record.jgFbName;
        item.jgFxName = record.jgFxName;
        item.jgFxProjectTypeCode = record.jgFxProjectTypeCode;
        item.sectionItemId = record.sectionItemId;
        item.type = record.type;
        item.jgInspItemCode = record.jgInspItemCode;
        item.id = record.id;
        items.push(item);
      }
    }
    req.itemInfos = items;
    return req;
  }
}
